import { Modal } from "@mui/material";
import TrashIcon from "assets/icons/TrashIcon";
import Portal from "components/Portal";
import ModalBox from "components/Shared/Modals/ModalBox";
import { TableContext } from "components/Table2";
import { useContext, useState } from "react";

export default function Mobile() {
  const table = useContext(TableContext);
  let indexBegin = 0;
  if (table.pagination) indexBegin = (table.pagination.page - 1) * table.pagination.perPage;
  const cols = table.cols || [];
  const headers = table.headers || [];
  const openRow = table.rows?.find((x) => x.id === table.state?.openRowId);
  return (
    <div className="flex flex-col gap-2 mt-2">
      {table.rows?.map((row, i, arr) => {
        const col = cols[0];
        let val = row[col.key];
        if (col.getValue) val = col.getValue(row);
        const { Comp, fixLeft, fixRight, style, getValue } = col;
        const last = table.withoutMenu && i === arr.length - 1;
        const o = col.options;

        return (
          <div
            key={i}
            className="w-full p-2 flex items-center justify-between rounded-md bg-slate-100"
            onClick={() => table.setState && table.setState((x) => ({ ...x, open: true, openRowId: row.id }))}
          >
            <div className="flex items-start">
              <div className="w-8 h-8 flex justify-center items-center text-sx">{indexBegin + i + 1}</div>
              {table.mobileLayout(row)}
            </div>
            <div
              className="flex justify-center items-center h-8 w-8"
              onClick={(e) => {
                e.stopPropagation();
                table.onDelete && table.onDelete(row);
              }}
            >
              <TrashIcon color="red" />
            </div>
          </div>
        );
      })}
      <Portal>
        <Modal
          open={!!table.state?.open}
          onClose={() => {
            table.setState && table.setState((x) => ({ ...x, open: false, openRowId: undefined }));
          }}
        >
          <ModalBox
            style={{
              container: { width: "100%", height: "100%", maxHeight: "100%" },
              body: { height: "100%", borderRadius: 0 },
              header: { borderRadius: 0 },
            }}
            onClose={() => {
              table.setState && table.setState((x) => ({ ...x, open: false, openRowId: undefined }));
            }}
            title=""
          >
            <div className="flex flex-col gap-6">
              {openRow ? (
                table.cols?.map((col, i, arr) => {
                  const { Comp, getValue } = col;
                  let val = openRow && (openRow as any)[col.key];
                  if (getValue) val = getValue(openRow);
                  if (i > 0 && val === undefined) return <></>;
                  return (
                    <div key={i} className="w-full flex flex-col gap-2">
                      <div className="text-sm px-2">{headers[i].label}</div>
                      <Comp
                        key={col.key}
                        colKey={col.key}
                        row={openRow}
                        data={col.data}
                        val={val}
                        options={col.options}
                        onChange={table.onChange}
                        style={{ borderColor: "#94a3b8", width: "100%" }}
                        inputProps={col.options?.inputProps}
                        withBorder={table.withBorder}
                      />
                    </div>
                  );
                })
              ) : (
                <div>what just happened</div>
              )}
            </div>
          </ModalBox>
        </Modal>
      </Portal>
    </div>
  );
}
